import {
    NgModule,
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    OnChanges,
    OnInit, SimpleChanges,
    ViewChild,
    ViewEncapsulation, ChangeDetectorRef,
} from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { StaticDataService } from '../../../services/static-data.service';


import { SchedulerService } from '../scheduler.service';
import { Globals } from '../../../globals';
import { AppointmentDataModel, AppoitmentDetaileModel, xDataAppointmentModel } from '../models/appoitment-model';
import { LocationModel, OperatoryModel } from '../models/operatory-model';
import { DxSchedulerModule } from 'devextreme-angular';
import moment from 'moment';
import { DxSchedulerComponent } from 'devextreme-angular';
import { ApptTypeEnum } from 'src/app/models/enum/appt-type.enum';
import { AppointmentDialogComponent } from '../../scheduling/dialog/appointment-dialog/appointment-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditAppointmentDialogComponent } from '../edit-appointment-dialog/edit-appointment-dialog.component';
import { AppointmentDialogDataV2Model } from '../models/edit-appoitment-data-model';
import { DoctorQueryOptionsModel } from '../../../models/doctors/doctor-query-options.model';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { DoctorsService } from '../../../services/doctors.service';
import { CaseProcedureConfigurationModel } from '../../../models/caseProcedures/case-procedure-configuration.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { ClientLocationDataModel } from '../../../models/clients/client-location-data.model';
import { Observable } from 'rxjs';
import { ApptStatusEnum } from '../../../models/enum/appt-status.enum';
import { formatDate } from '@angular/common';
import { PatientCheckinDialogComponent } from '../../../dialog/patient-checkin-dialog/patient-checkin-dialog.component';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { DataAppointmentModel } from '../../../models/appointments/data-appointment.model';
import { MessagingService } from '../../../services/messaging.service';
import { TdoSharedService } from '../../tdo-shared/tdo-shared.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { WaitListDialogComponent } from "../../scheduling/wait-list-dialog/wait-list-dialog.component";
import { WaitListDialogV2Component } from "../wait-list-dialog-v2/wait-list-dialog-v2.component";
import { LabelService } from 'src/app/services/label.service';
import { FormattedLabelEnum } from 'src/app/models/enum/labels/formatted-label.enum';



@Component({
    selector: 'app-tdo-scheduler',
    templateUrl: './tdo-scheduler.component.html',
    styleUrls: ['./tdo-scheduler.component.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TdoSchedulerComponent implements OnInit {
    tdoScheduler: DxSchedulerComponent;

    @ViewChild('tdoScheduler', { static: false }) set tdoxScheduler(content: DxSchedulerComponent) {
        if (content) {
            this.tdoScheduler = content;
        }
    }

    visibleStartHour: number = 7;
    visibleEndHour: number = 17;

    selectedViewOption: string = '1';

    appointmentStatusEnums: EnumValidValueItemModel[];

    cellDuration: number = 15;
    viewType: string = 'day';

    currentDateAndTime: Date;
    minEndDateAndTime: Date;
    maxStartDateAndTime: Date;
    selectedCellData = {
        StartDate: '',
        EndDate: '',
        Resource_OperatoryId: '',
        enumApptTypeId: '',
        enumApptStatusId: '',
        CaseProcedureId: ''
    };
    selectedOperatory: any;
    isAppointmentClick: boolean = false;

    viewTypeButtonCaption: string = 'Current View: ' + 'Standard View';

    isCellContextMenuVisible = false;
    isAppContextMenuVisible = false;
    rightClickAppointmentOptions = [
        { ctxId: 1, text: 'Edit' },
        { ctxId: 2, text: 'Cancel Appointment' },
        { ctxId: 4, text: 'Open Patient' },
        { ctxId: 5, text: 'Check In' }
    ];

    rightClickScheduleOptions = [{ ctxId: 1, text: '.' }];
    todayDate: moment.Moment = moment();

    isTodayAppointment: boolean = false;
    isAppointmentOpen: boolean = false;
    schCurrentTDOCID: number = 13;
    schCurrentLOCID: number = 13;
    schCurrentFromDate: string = '2024-08-5';
    schCurrentToDate: string = '2024-08-5';
    tdoCurrentDate: Date = new Date(2024, 7, 5);  // 2024-8-3

    appointmentsInRange: AppointmentDataModel[] = [];  // contains list of appoitments for TDOCID  for date range

    appotmentsInRangeToShow: AppointmentDataModel[] = [];  // filterd list from appotmentsInRange : locatoions, operatories

    practiceOperatories: OperatoryModel[] = [];
    practiceOperatoriesShow: OperatoryModel[] = [];
    practiceOperatoriesShowFilter: OperatoryModel[] = [];
    practiceOperatoriesShowFilterIDs: any[] = [];

    praticeLocations: LocationModel[] = [];
    selectedLocations: LocationModel[] = [];
    selectedLocationsIDs: any[];

    protected readonly ApptTypeEnum = ApptTypeEnum;

    currentAppointment: AppointmentDialogDataV2Model;

    allDoctorsList: DoctorDataModel[] = [];

    procedures: CaseProcedureConfigurationModel[] = [];

    showTemplate: boolean = false;

    TDOUserID: string; // = this.localStorageService.currentUserData.authdata.userid;
    isReschedule: boolean = false;



    constructor(
        private readonly dataService: SchedulerService,
        public globals: Globals,
        public dialog: MatDialog,
        private readonly doctorsService: DoctorsService,
        private readonly cd: ChangeDetectorRef,
        private readonly staticDataService: StaticDataService,
        private readonly authenticationService: AuthenticationService,
        private readonly messagingService: MessagingService,
        private readonly tdoShared: TdoSharedService,
        private readonly localStorageService: LocalStorageService,
        private readonly labelService: LabelService
    ) {


    }

    onViewControlsCreated(e) {
        console.log('onViewControlsCreated', e);
    }

    goToPreviousDay() {

        this.tdoCurrentDate = moment(this.tdoCurrentDate).subtract(1, 'days').toDate();

    }
    goToNextDay() {

        this.tdoCurrentDate = moment(this.tdoCurrentDate).add(1, 'days').toDate();
    }
    goToPreviousMonth() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).subtract(1, 'months').toDate();

    }
    goToNextMonth() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).add(1, 'months').toDate();

    }
    goToPreviousWeek() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).subtract(7, 'days').toDate();

    }
    goToNextWeek() {
        this.tdoCurrentDate = moment(this.tdoCurrentDate).add(7, 'days').toDate();

    }


    goToToday() {
        this.tdoCurrentDate = new Date();
    }
    gettdoDate() {
        return this.tdoCurrentDate;

    }
    onDateChange(e) {

        this.tdoCurrentDate = e.value;
        // console.log('date change', e);


    }

    async getAppointmentLabels(appointment: AppointmentDataModel, labelType: FormattedLabelEnum) {
        if (appointment.PatientId === null)
            return '';
        const labelsRes = await this.labelService.getLabelTokensByFormattedLabel(
            labelType,
            appointment.PatientId,
            appointment.PatientCaseId, null,
            appointment.AppointmentId,
        ).toPromise();
        let labelText = '';
        if (labelsRes) {
            for (let label of labelsRes.filter(l => (l.value ?? '').length > 0)) {
                labelText += `${label.Prefix} ${label.value} ${label.Sufix}`;
                if (label.isEndOfLine) 
                    labelText += '<br/>';
            }
        }
        return labelText;
    }

    ngOnInit() {
        this.TDOUserID = this.localStorageService.currentUserData.authdata.userid;
        this.tdoCurrentDate = new Date();
        this.schCurrentTDOCID = parseInt(this.globals.TDOCID);
        this.schCurrentLOCID = parseInt(this.globals.LOCID);
        this.authenticationService.currentUser.subscribe(u => {
        });

        this.selectedLocationsIDs = [];
        this.dataService.getLocations(this.globals.TDOCID).subscribe(res => {
            this.praticeLocations = res;
            const storedLastLocations = this.globals.calendarV2SelectedLocations as LocationModel[];
            if (storedLastLocations) {
                storedLastLocations.forEach(a => {
                    this.selectedLocations.push(a);
                    this.selectedLocationsIDs.push(a.LOCID);
                });
            }
            else {
                const a = this.praticeLocations.find(f => f.LOCID === this.schCurrentLOCID);
                this.selectedLocations.push(a);
                this.selectedLocationsIDs.push(a.LOCID);
            }

            this.dataService.getOperatories(this.globals.TDOCID).subscribe(res => {
                this.practiceOperatories = res;
                this.practiceOperatoriesShow = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID)).sort(b => b.LOCID).sort(s => s.OperatoryOrder);

                this.practiceOperatoriesShowFilter = [];
                const storedLastOps = this.globals.calendarV2SelectedOperatories as any[];
                if (storedLastOps) {
                    storedLastOps.forEach(a => {
                        this.practiceOperatoriesShowFilterIDs.push(a);

                        let z = this.practiceOperatoriesShow.find(f => f.OperatoryId == a);
                        this.practiceOperatoriesShowFilter.push(z);

                    });

                }
                else {
                    this.practiceOperatoriesShowFilter = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID)).sort(b => b.LOCID).sort(s => s.OperatoryOrder);

                }

                this.schCurrentFromDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
                this.schCurrentToDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
            });

            this.loadBusinessHours();

        });



        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isLazyLoad = false;
        doctorQueryModel.isIncludeTdo = true;
        doctorQueryModel.isIncludeReferring = true;   // zoli  was false
        this.doctorsService.getDoctors(doctorQueryModel).subscribe((allDoctors) => {
            this.allDoctorsList = allDoctors;
        });

        this.dataService.getProcedureGroup('AA000001-0000-0000-0000-000000000001').subscribe((res: CaseProcedureConfigurationModel[]) => {
            // appointment procedures only
            this.procedures = res;
        });

        this.setupValidValues();

        this.tdoShared.getUserParams(this.TDOUserID, 'tdo-calendar-view').subscribe(res => {
            this.selectedViewOption = res.ParameterValue;

            this.btnViewTypeClicked(null, this.selectedViewOption);


        }, error => {

            console.log('Error', error);
        });




    }
    private setupValidValues(): void {


        this.staticDataService.getValidValueItemsByName('enumApptStatus').subscribe(res => {

            this.appointmentStatusEnums = res;


        });


    }

    private loadBusinessHours() {

        // //this.globals.TDOCID
        // this.selectedLocations
        const zs = this.selectedLocations.map(l => l.LOCID);

        this.dataService.getBusinessHours(this.globals.TDOCID, zs).subscribe(res => {
            console.log('business hours', res);

        });


    }


    added: boolean = false;
    onContentReadyTDOScheduler(e) {
    }

    // maybe useful
    waitFor(variable, callback) {
        // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
        var interval = setInterval(function () {
            if (window[variable]) {
                clearInterval(interval);
                callback();
            }
        }, 200);
    }



    onOptionChanged(e) {
        if (e.name === 'currentDate') {


            this.tdoCurrentDate = e.value;
            if (this.tdoCurrentDate.getFullYear() < 1900) {
                return;
            }

            this.btnViewTypeClicked(null, this.selectedViewOption);
        }
    }


    btnViewTypeClicked(event, e) {

        this.selectedViewOption = e;

        this.tdoShared.saveUserParams(this.TDOUserID, 'tdo-calendar-view', this.selectedViewOption).subscribe(res => {


        }, error => {
            console.log('error', error);
        });

        if (event !== null) {
            this.viewTypeButtonCaption = 'Current View: ' + (event.target as HTMLButtonElement).textContent;
        }
        else {
            if (this.selectedViewOption == '1') {
                this.viewTypeButtonCaption = 'Current View: Standard View';
            } else if (this.selectedViewOption == '2') {
                this.viewTypeButtonCaption = 'Current View: Day Detail View';
            } else if (this.selectedViewOption == '3') {
                this.viewTypeButtonCaption = 'Current View: Week View';
            } else if (this.selectedViewOption == '4') {
                this.viewTypeButtonCaption = 'Current View: Work Week View';
            } else if (this.selectedViewOption == '5') {
                this.viewTypeButtonCaption = 'Current View: Month View';
            }

        }


        if (this.selectedViewOption === '1' || this.selectedViewOption === '2') {
            this.schCurrentFromDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(this.tdoCurrentDate).format('YYYY-MM-DD');
            this.loadAppoitments();
            this.viewType = 'day';
        }
        else if (e === '3') {

            const prevMonday = new Date(this.tdoCurrentDate);
            prevMonday.setDate(this.tdoCurrentDate.getDate() - (this.tdoCurrentDate.getDay() + 6) % 7);

            const nextSunday = new Date(this.tdoCurrentDate);
            nextSunday.setDate(this.tdoCurrentDate.getDate() + (7 - this.tdoCurrentDate.getDay()));

            this.schCurrentFromDate = moment(prevMonday).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(nextSunday).format('YYYY-MM-DD');

            this.loadAppoitments();
            this.viewType = 'week';
        }
        else if (e === '4') {
            const prevMonday = new Date(this.tdoCurrentDate);
            prevMonday.setDate(this.tdoCurrentDate.getDate() - (this.tdoCurrentDate.getDay() + 6) % 7);

            const nextSunday = new Date(this.tdoCurrentDate);
            nextSunday.setDate(this.tdoCurrentDate.getDate() + (7 - this.tdoCurrentDate.getDay()));

            this.schCurrentFromDate = moment(prevMonday).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(nextSunday).format('YYYY-MM-DD');

            this.loadAppoitments();

            this.viewType = 'workWeek';
        }
        else if (e === '5') {

            const firstOfMonth = new Date(this.tdoCurrentDate.getFullYear(), this.tdoCurrentDate.getMonth(), 1);
            const lastOfMonth = new Date(this.tdoCurrentDate.getFullYear(), this.tdoCurrentDate.getMonth() + 1, 0);

            this.schCurrentFromDate = moment(firstOfMonth).format('YYYY-MM-DD');
            this.schCurrentToDate = moment(lastOfMonth).format('YYYY-MM-DD');

            this.loadAppoitments();

            this.viewType = 'month';
        }

    }



    removeLOCTag(d) {
        console.log(d);
        const i = this.selectedLocationsIDs.findIndex(f => f === d.LOCID);

        this.selectedLocationsIDs.splice(i, 1);

        this.onLocationClose(d);
        //xz
    }

    removeOpTag(d) {

        let i = this.practiceOperatoriesShowFilterIDs.findIndex(f => f === d.OperatoryId);

        let lf = this.practiceOperatoriesShowFilter;
        this.practiceOperatoriesShowFilter = [];

        lf.splice(i, 1);

        this.practiceOperatoriesShowFilter = [...lf];
        this.practiceOperatoriesShowFilterIDs = [];

        this.practiceOperatoriesShowFilter.forEach(f => {
            this.practiceOperatoriesShowFilterIDs.push(f.OperatoryId);

        });

        this.globals.calendarV2SelectedOperatories = this.practiceOperatoriesShowFilterIDs;
    }

    onLocationClose(event) {

        if (this.selectedLocationsIDs.length === 0) {
            return;
        }
        this.selectedLocations = [];
        this.selectedLocationsIDs.forEach(a => {
            const b = new LocationModel();
            b.LOCID = a;
            this.selectedLocations.push(b);
        });

        this.practiceOperatoriesShow = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID)).sort(b => b.LOCID).sort(s => s.OperatoryOrder);
        this.practiceOperatoriesShowFilter = this.practiceOperatories.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID)).sort(b => b.LOCID).sort(s => s.OperatoryOrder);
        this.appotmentsInRangeToShow = this.appointmentsInRange.filter(f => this.selectedLocations.find(z => z.LOCID === f.LOCID));

        this.globals.calendarV2SelectedLocations = this.selectedLocations;

        this.practiceOperatoriesShowFilterIDs = [];
        this.practiceOperatoriesShowFilter.forEach(f => {

            this.practiceOperatoriesShowFilterIDs.push(f.OperatoryId);
        });

    }
    onpracticeOperatoriesFilterChange(event: any) {
        this.practiceOperatoriesShowFilter = [];
        this.practiceOperatoriesShowFilterIDs.forEach(a => {

            let z = this.practiceOperatoriesShow.find(f => f.OperatoryId == a);
            this.practiceOperatoriesShowFilter.push(z);

        });
        this.practiceOperatoriesShowFilter = this.practiceOperatoriesShowFilter.sort((a, b) => (a.OperatoryOrder < b.OperatoryOrder ? -1 : 1));

        this.practiceOperatoriesShowFilterIDs = [];
        this.practiceOperatoriesShowFilter.forEach(x => {
            this.practiceOperatoriesShowFilterIDs.push(x.OperatoryId);
        });

        this.globals.calendarV2SelectedOperatories = this.practiceOperatoriesShowFilterIDs;
    }




    loadAppoitments() {

        this.dataService.getAppointments(this.globals.TDOCID, this.schCurrentFromDate, this.schCurrentToDate).subscribe(ares => {
            this.appotmentsInRangeToShow = [];

            this.appointmentsInRange = ares;

            this.appointmentsInRange.forEach(async a => {
                a.zendDate = new Date(a.endDate);
                a.zstartDate = new Date(a.startDate);
                a.LabelLine1 = await this.getAppointmentLabels(a, FormattedLabelEnum.AppointmentLine1);
                a.LabelTooltip = await this.getAppointmentLabels(a, FormattedLabelEnum.AppointmentDetails);
                if (a.LabelLine1 === '') 
                    a.LabelLine1= 'No Label setup';
                if (a.LabelTooltip === '') 
                    a.LabelLine1= 'No Tooltip setup';
            }
            );
            this.practiceOperatoriesShow = this.practiceOperatories.filter(f => f.LOCID === this.schCurrentLOCID).sort(s => s.OperatoryOrder);
            this.appotmentsInRangeToShow = this.appointmentsInRange.filter(f => f.LOCID === this.schCurrentLOCID);
        });

    }


    loadAppoitmentsFlags(flags: string) {

        if (flags) {
            console.log('loadAppoitmentsFlags:', flags);
            const zz = JSON.parse(flags);
            return zz.aflag;
        }
        return [];

    }

    loadPatientFlags(flags: string) {
        if (flags) {
            const zz = JSON.parse(flags);
            return zz.pflag;
        }
        return [];
    }


    showAppoitmentData(appt) {
        // console.log('app: ', appt);

        return 'APPT';
    }

    onAppointmentUpdated(app) {
        // on drag updates:
        // - drag whole appotment: zstartDate, zendDate
        // - change duration drag: zstartDate, zendDate
        // - change operatory: OperatoryId


        app.appointmentData.startDate = this.formatDateTime(app.appointmentData.zstartDate);
        app.appointmentData.endDate = this.formatDateTime(app.appointmentData.zendDate);


        // update
        this.dataService.updateAppoitment(app.appointmentData).subscribe(res => {
            console.log('updated appoitment', res);

        });


    }

    formatDate2YYYY_MM_DD(date) {
        // returns YYYY-MM-DD
        // tslint:disable-next-line:one-variable-per-declaration prefer-const
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        // tslint:disable-next-line:prefer-const
        const year = d.getFullYear();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        return [year, month, day].join('-');
    }

    onAppointmentContext(event: any) {

        this.currentAppointment = new AppointmentDialogDataV2Model();
        this.currentAppointment.currentLocationId = this.globals.LOCID;
        this.currentAppointment.timeIncrement = 30;    // from config
        this.currentAppointment.procedures = this.procedures;
        this.currentAppointment.isReadOnly = false;
        this.currentAppointment.appointment = event.appointmentData;
        this.currentAppointment.allDoctors = this.allDoctorsList;
        this.currentAppointment.appointment.dataAppoitmentDetails = [];
        this.currentAppointment.cancellingAppointment = false;
        this.currentAppointment.confirmingAppointment = false;
        this.currentAppointment.operatories = this.practiceOperatories;
        this.isAppointmentClick = true;

        if (this.formatDate2YYYY_MM_DD(new Date(this.currentAppointment.appointment.startDate).toDateString()) === this.formatDate2YYYY_MM_DD(this.todayDate.format())) {
            this.isTodayAppointment = true;
        }
        if (this.currentAppointment.appointment.isReservation) {
            // this.rightClickAppointmentOptions = [{ ctxId: 2, text: 'Cancel Appointment' }];
            this.rightClickAppointmentOptions = [];
            if (this.authenticationService.currentUserValue.authdata.userid === this.currentAppointment.appointment.xauditCreatedBy) {
                this.rightClickAppointmentOptions.push({ ctxId: 7, text: 'Remove Reserved Time Slot' });
            }
        }
        else
            if (this.currentAppointment.appointment.enumApptTypeId == ApptTypeEnum.BlockIn || this.currentAppointment.appointment.enumApptTypeId == ApptTypeEnum.BlockOut) {

                this.rightClickAppointmentOptions = [];
                if (this.authenticationService.currentUserValue.authdata.userid === this.currentAppointment.appointment.xauditCreatedBy) {
                    this.rightClickAppointmentOptions.push({ ctxId: 7, text: 'Remove Block' });  // same as reservation
                }
            }
            else if ((this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Remote_Checked_In ||
                this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Checked_in ||
                this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Seated) && this.isTodayAppointment) {
                this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 4, text: 'Open Patient' }, { ctxId: 6, text: 'Check Out' }];
            }
            else if (this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Checked_out) {
                this.rightClickAppointmentOptions = [{ ctxId: 4, text: 'Open Patient' }];
            }
            else if (this.currentAppointment.appointment.enumApptStatusId === ApptStatusEnum.Canceled) {
                this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 4, text: 'Open Patient' }];
            }
            else if (this.isTodayAppointment) {
                this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 4, text: 'Open Patient' }, { ctxId: 5, text: 'Check In' }];
                if (this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Confirmed) { this.rightClickAppointmentOptions.push({ ctxId: 8, text: 'Confirm' }); }
            }
            else if ((this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Remote_Checked_In &&
                this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Checked_in &&
                this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Seated && this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Checked_out)) {
                this.rightClickAppointmentOptions = [{ ctxId: 1, text: 'Edit' }, { ctxId: 2, text: 'Cancel Appointment' }, { ctxId: 4, text: 'Open Patient' }];
                if (this.currentAppointment.appointment.enumApptStatusId !== ApptStatusEnum.Confirmed) { this.rightClickAppointmentOptions.push({ ctxId: 8, text: 'Confirm' }); }
            }






    }
    ctxMenuItemClickApp(e) {
        // console.log('ctxMenuItemClickApp', e);

        // this.triggerChangeDetection();

        // this.tdoScheduler.selectedCellData = [];
        // this.tdoScheduler.selectedCellData.push({ startDate: this.selectedCellData.StartDate, endDate: this.selectedCellData.EndDate, groups: { Resource_OperatoryId: this.selectedCellData.Resource_OperatoryId } });

        // this.selectedAppt = this.currentAppointment.appointment; //JSON.parse(JSON.stringify(this.selectedCellData));




        // const patient = JSON.parse(this.currentAppointment.appointment?.PatientFullInfo);
        // if (patient) {
        //    patientName = `${patient.FirstName} ${patient.LastName}`;
        // }

        this.isAppContextMenuVisible = false;
        switch (e.itemData.ctxId) {
            case 1:
                // edit
                this.currentAppointment.cancellingAppointment = false;
                this.currentAppointment.confirmingAppointment = false;
                console.log('edit appointment', this.currentAppointment);
                // this.onAppointmentFormOpening(e, 'edit');
                this.showCustomPopup('edit');
                break;
            case 2:
                // cancel
                this.currentAppointment.confirmingAppointment = false;
                this.currentAppointment.cancellingAppointment = true;

                console.log('cancel appointment', this.currentAppointment);


                this.showCustomPopup('edit');

                /// / CHANGE TO DIALOG CANCEL END

                break;
            case 3:
                // Reschedule
                // var enumStatusReschedule: string = '00000072-0000-0000-0000-000000000007';
                // onAppointmentFormOpening(e, true, '');
                break;
            case 4: // Open patient
                console.log('open patient', this.currentAppointment.appointment);
                this.changeToPatientAndGotoCaseView(this.currentAppointment.appointment);

                break;
            case 5: // Check in
                console.log('check in appointment', this.currentAppointment.appointment);

                const config = new MatDialogConfig();
                config.panelClass = 'dialog';
                config.data = this.currentAppointment.appointment; //  this.selectedAppt;
                this.dialog.open(PatientCheckinDialogComponent, config).afterClosed().subscribe((res) => {
                    console.log('PatientCheckinDialogComponent dialog afterclosed', res);
                    if (res) {
                        const appointmentSearchDateRange = this.formatDate2YYYY_MM_DD(this.tdoCurrentDate) + ' ' + this.formatDate2YYYY_MM_DD(this.tdoCurrentDate);
                        console.log('PatientCheckinDialogComponent call to load appointments');
                        this.loadAppoitments();


                    }
                });
                break;
            case 6:  // Check out
                console.log('check out appointment', this.currentAppointment.appointment);
                localStorage.setItem('selectedAppt', JSON.stringify(this.currentAppointment.appointment));
                let patientName = '';

                patientName = this.currentAppointment.appointment?.PatientName;

                this.messagingService.sendParentMessage(MessagingConstants.PATIENT_CHANGED, {
                    PatientID: this.currentAppointment.appointment?.PatientId,
                    PatientName: patientName,
                    Process: MessagingConstants.CHECKOUT_PATIENT_START,
                    PatientCaseId: this.currentAppointment.appointment.PatientCaseId
                });

                break;
            case 7:  // delete if reserved slot
                console.log('delete reserved slot', this.currentAppointment.appointment);
                this.dataService.deleteAppointment(this.currentAppointment.appointment.AppointmentId).subscribe((res) => {
                    console.log('deleteAppointment call to load appointments');
                    this.loadAppoitments();
                });

                break;
            case 8:  // Confirm
                console.log('confirm appointment', this.currentAppointment.appointment);
                this.currentAppointment.cancellingAppointment = false;
                this.currentAppointment.confirmingAppointment = true;

                this.showCustomPopup('edit');

                break;



            default:
            // code block
        }


    }

    changeToPatientAndGotoCaseView(appointmentData: AppointmentDataModel) {


        if (!this.isBlockAppt(appointmentData)) {


            const patientName = appointmentData.PatientName;

            this.messagingService.sendParentMessage(MessagingConstants.PATIENT_CHANGED, {
                PatientID: appointmentData.PatientId,
                PatientName: patientName,
                Process: MessagingConstants.RELOAD_SCHEDULE_APPOINTMENTS,
                clearCurrentQuery: false
            });
        }
    }

    ctxMenuItemClickCell(e) {
        switch (e.itemData.ctxId) {

            case 9: // reschedule
                if (this.globals.RescheduleAppointmentRequest) {
                    //console.log(' appointment  ',this.globals.RescheduleAppointmentRequest);
                    //console.log('rescedule appointment to here ', this.currentAppointment.appointment);


                    // move apptment to current selected date time


                    let appointment = {
                        AppointmentId: this.globals.RescheduleAppointmentRequest.AppointmentId,
                        note: this.globals.RescheduleAppointmentRequest.Reschedule_Note,
                        newStartDate: this.currentAppointment.appointment.startDate,
                        newOperatoryId: this.currentAppointment.appointment.OperatoryId

                    };



                    this.dataService.rescheduleAppoitment(appointment).subscribe(res => {

                        this.globals.RescheduleAppointmentRequest = null;
                        console.log('rescheduleAppoitment call to load appointments');
                        this.loadAppoitments();

                    });




                }
            default:

        }
    }

    onMouseUp(event: MouseEvent) {


        if (event.target instanceof HTMLTableCellElement) {

            if (event.target.className.indexOf('dx-scheduler-time-panel-cell') > -1) {
                return;
            }

            // new appoitment
            this.currentAppointment = new AppointmentDialogDataV2Model();
            this.currentAppointment.currentLocationId = this.globals.LOCID;
            this.currentAppointment.timeIncrement = 30;    // from config
            this.currentAppointment.procedures = this.procedures;
            this.currentAppointment.isReadOnly = false;
            this.currentAppointment.appointment = null;
            this.currentAppointment.allDoctors = this.allDoctorsList;
            this.currentAppointment.cancellingAppointment = false;
            this.currentAppointment.confirmingAppointment = false;
            this.currentAppointment.operatories = this.practiceOperatories;



            // new appoitment
            const appt = new AppointmentDataModel();
            appt.LOCID = parseInt(this.globals.LOCID);
            const imax = this.tdoScheduler.selectedCellData.length - 1;
            appt.OperatoryId = this.tdoScheduler.selectedCellData[imax].groups.OperatoryId;

            appt.isReservation = false;
            // appt.Reservation_AppointmentId = this.currentAppointment.appointment.Reservation_AppointmentId;

            appt.startDate = this.formatDateTime(this.tdoScheduler.selectedCellData[0].startDate);

            // console.log('.toLocaleString', this.tdoScheduler.selectedCellData[0].startDate.toLocaleString());
            // console.log('.toDateString', this.tdoScheduler.selectedCellData[0].startDate.toDateString());
            // console.log('.toISOString', this.tdoScheduler.selectedCellData[0].startDate.toISOString());
            // console.log('.formatDateTime', this.formatDateTime( this.tdoScheduler.selectedCellData[0].startDate));




            appt.endDate = this.formatDateTime(this.tdoScheduler.selectedCellData[this.tdoScheduler.selectedCellData.length - 1].endDate);

            appt.enumApptTypeId = this.ApptTypeEnum.Scheduled;
            appt.enumApptStatusId = this.appointmentStatusEnums[0].ValidValueItemId;  // creted
            appt.CaseProcedureId = '';
            appt.AppointmentId = undefined;
            appt.dataAppoitmentDetails = [];

            this.currentAppointment.appointment = appt;




            this.currentAppointment.appointment.isReservation = true;

            if (!this.globals.RescheduleAppointmentRequest) {
                this.dataService.saveNewAppoitment(this.currentAppointment.appointment).subscribe(res => {

                    // this.currentAppointment.appointment.AppointmentId = res.AppointmentId;
                    this.currentAppointment.appointment.Reservation_AppointmentId = res.AppointmentId;

                    // this.onAppointmentFormOpening(event, 'new');


                    this.showCustomPopup('new');


                });
            }
            else {

                if (this.globals.RescheduleAppointmentRequest) {
                    this.rightClickScheduleOptions = null;
                    this.rightClickScheduleOptions = [{ ctxId: 9, text: 'Reschedule Here' }];
                    return;
                }
            }




        }

    }

    formatDateTime(date) {
        let ret: string = '';

        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) { month = '0' + month; }
        if (day.length < 2) { day = '0' + day; }

        ret = year + '-' + month + '-' + day;


        let h: string = '' + d.getHours();
        let m: string = '' + d.getMinutes();
        if (h.length < 2) { h = '0' + h; }
        if (m.length < 2) { m = '0' + m; }

        ret = ret + ' ' + h + ':' + m;



        return ret;


    }


    onCellClick(e: any) {

        this.isAppointmentClick = false;
        // console.log('on click', e);
        console.log('on cell click data', e);





    }
    onAppointmentClick(e: any) {
        this.isAppointmentClick = true;
        console.log('on appoitment click data', e.appointmentData);

        this.currentAppointment = new AppointmentDialogDataV2Model();
        this.currentAppointment.currentLocationId = this.globals.LOCID;
        this.currentAppointment.timeIncrement = 30;    // from config
        this.currentAppointment.procedures = this.procedures;
        this.currentAppointment.isReadOnly = false;
        this.currentAppointment.appointment = e.appointmentData;
        this.currentAppointment.allDoctors = this.allDoctorsList;
        this.currentAppointment.appointment.dataAppoitmentDetails = [];
        this.currentAppointment.cancellingAppointment = false;
        this.currentAppointment.confirmingAppointment = false;
        this.currentAppointment.operatories = this.practiceOperatories;


    }

    onOpenMedicalInformationFormDialog(app: AppointmentDataModel) {


    }


    isBlockAppt(appt: AppointmentDataModel) {
        return appt.enumApptTypeId == this.ApptTypeEnum.BlockIn || appt.enumApptTypeId == this.ApptTypeEnum.BlockOut;
    }

    // on double click on appoitment
    overrideDefaultPopup(event) {
        if (event.appointmentData) {
            let appt = event.appointmentData as AppointmentDataModel;
            event.cancel = true;
            if (appt.parentAppointmentId) {
                appt = this.appointmentsInRange.find(p => p.AppointmentId.toLowerCase() === appt.parentAppointmentId.toLowerCase());
            }
            this.showCustomPopup('edit');
        }
    }

    setCurrentDateAndTime() {
        const now = new Date();
        const currentHours = now.getHours();
        let currentMinutes = now.getMinutes();

        if (currentMinutes === 0) {
            // do nothing
        } else if (currentMinutes < 15) {
            currentMinutes = 0;
        } else if (currentMinutes < 30) {
            currentMinutes = 15;
        } else if (currentMinutes < 45) {
            currentMinutes = 30;
        } else {
            currentMinutes = 45;
        }

        this.currentDateAndTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentHours, currentMinutes);
        this.maxStartDateAndTime = new Date(this.selectedCellData.EndDate);
        this.minEndDateAndTime = new Date(this.selectedCellData.StartDate);

    }

    // onAppointmentFormOpening(e, action: string = 'edit') {
    //     // is this needed?
    //
    //     this.isAppointmentClick = false;
    //
    //     if (action === 'new') {
    //         const appt = new AppointmentDataModel();
    //         appt.LOCID = parseInt(this.globals.LOCID);
    //         const imax = this.tdoScheduler.selectedCellData.length - 1;
    //         appt.OperatoryId = this.tdoScheduler.selectedCellData[imax].groups.OperatoryId;
    //
    //         appt.isReservation = false;
    //         appt.Reservation_AppointmentId = this.currentAppointment.appointment.Reservation_AppointmentId;
    //
    //         appt.startDate = this.tdoScheduler.selectedCellData[0].startDate.toLocaleString();
    //         appt.endDate = this.tdoScheduler.selectedCellData[this.tdoScheduler.selectedCellData.length - 1].endDate.toLocaleString();
    //
    //         appt.enumApptTypeId = this.ApptTypeEnum.Scheduled;
    //         appt.enumApptStatusId = this.appointmentStatusEnums[0].ValidValueItemId;  // creted
    //         appt.CaseProcedureId = '';
    //         appt.AppointmentId = undefined;
    //         appt.dataAppoitmentDetails = [];
    //         e.cancel = true;
    //         this.showCustomPopup( 'new');
    //     }
    //     if (action === 'edit') {
    //         e.cancel = true;
    //
    //         const appt = new AppointmentDataModel();
    //         this.showCustomPopup( 'new');
    //     }
    //
    //
    //
    // }

    // async showCustomPopup(appointment: AppointmentDataModel, action: string = 'edit') {
    async showCustomPopup(action: string = 'edit') {

        if (action === 'new') {
            // this.currentAppointment = new AppointmentDialogDataV2Model();
            // this.currentAppointment.currentLocationId = this.globals.LOCID;
            // this.currentAppointment.timeIncrement = 30;    // from config
            // this.currentAppointment.procedures = this.procedures;
            // this.currentAppointment.isReadOnly = false;
            // this.currentAppointment.appointment = appointment;
            // this.currentAppointment.allDoctors = this.allDoctorsList;
            // this.currentAppointment.appointment.dataAppoitmentDetails = [];
            // this.currentAppointment.cancellingAppointment = false;
            // this.currentAppointment.confirmingAppointment = false;
            // this.currentAppointment.operatories = this.practiceOperatories;

        }

        if (action === 'edit') {

        }
        if (action === 'cancel') {

            this.currentAppointment.confirmingAppointment = false;
            this.currentAppointment.cancellingAppointment = true;

        }


        const config = new MatDialogConfig();
        config.width = '70%';
        config.height = '80%';
        config.data = this.currentAppointment;
        this.isAppointmentOpen = true;

        // console.log('showCustomPopup ', this.currentAppointment);


        this.dialog.open(EditAppointmentDialogComponent, config).afterClosed().subscribe(
            (res: AppointmentDataModel) => {
                // console.log('dialog closed new appoitment', res);
                // if new appoitment add to list and refresh scheduler
                console.log('EditAppointmentDialogComponent call to load appointments');
                this.loadAppoitments();


                this.isAppointmentOpen = false;
            }



        );




    }


    onClickClearReschedule() {
        this.globals.RescheduleAppointmentRequest = null;

    }
    onOpenWaitListComponent() {
        const config = new MatDialogConfig();
        config.width = '800px';
        config.height = '800px';
        config.panelClass = 'dialog';
        //config.data = this.appointmentDialogData;
        const dialogRef = this.dialog.open(WaitListDialogV2Component, config);
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.isReschedule = true;

                if (this.globals.RescheduleAppointmentRequest) {
                    this.rightClickScheduleOptions = null;
                    this.rightClickScheduleOptions = [{ ctxId: 9, text: 'Reschedule Here' }];
                    return;
                }

            }
        }, err => {
            console.log(err);
        });

    }



}
